export default "__VITE_ASSET__DmjM$EoV__"